const SectionAbout = Class(
	/**
	 * @lends {SectionAbout#}
	 */
	{
		bodyClass: 'small-nav',
		menuItem: 'about',

		__construct: function () {
			this.node = mkE({
				tag: 'div',
				id: 'about-us',
				className: 'container'
			});
		},

		draw: function () {
			let heroUrl = {
				tag: 'a',
				href: D.url(D.Lang.get('about.button.link')),
				className: 'button button-large button-pink',
				text: D.Lang.get('about.button')
			};
			new T.Hero({
				backgroundClass: `background-picture-about`,
				backgroundOverlay: true,
				backgroundArrow: true,
				backgroundMask: 'white',
				title: D.Lang.get('about.title'),
				text: D.Lang.get('about.text'),
				button: heroUrl
			}).append(this.layout.ct());
			this.node.append(this.layout.ct());

			mkE({
				tag: 'div',
				className: 'team',
				els: [
					{
						tag: 'h2',
						className: 'h1',
						text: D.Lang.get('about.team.title')
					},
					{
						tag: 'p',
						text: D.Lang.get('about.info.text')
					},
					{
						tag: 'div',
						className: 'people',
						els: [
							{
								tag: 'div',
								className: 'col',
								els: [
									this._person('liene'),
									this._person('janis'),
									this._person('gustavs')
								]
							},
							{
								tag: 'div',
								className: 'col',
								els: [
									this._person('raitis'),
									this._person('juta'),
									this._person('krists')
								]
							},
							{
								tag: 'div',
								className: 'col',
								els: [
									this._person('deniels'),
									this._person('zane'),
									this._person('davis')
								]
							},
							{
								tag: 'div',
								className: 'col',
								els: [
									this._person('annija'),
									this._person('everts'),
									this._person('lauris'),
									this._person('luize')
								]
							}
						]
					}
				]
			}).append(this.node);
			if( D.PRICE.price || true ) {
				mkE({
					tag: 'div',
					className: 'bottom',
					els: [
						{
							tag: 'h2',
							className: 'with-arrows h1',
							text: D.Lang.get('about.bottom.title')
						},
						{
							tag: 'div',
							className: 'button-container',
							els: [
								{
									tag: 'a',
									className: 'button button-turquoise button-large',
									href: D.ID ? D.url('/events') : D.url('/sign-up?redirect=' + encodeURIComponent(D.url('/events'))),
									text: D.Lang.get('about.bottom.button')
								}
							]
						}
					]
				}).append(this.node);
			} else {
				mkE({
					tag: 'div',
					className: 'bottom',
					els: [
						{
							tag: 'h1',
							className: 'with-arrows',
							text: D.Lang.get('about.bottom.title')
						},
						{
							tag: 'div',
							className: 'button-container',
							els: [
								{
									tag: 'a',
									className: 'button button-turquoise button-large',
									href: D.url('/#newsletter'),
									text: D.Lang.get('about.bottom.buttonNewsletter')
								}
							]
						}
					]
				}).append(this.node);
			}
			this.ready();
		},

		_person: function ( name ) {
			return mkE({
				tag: 'div',
				className: 'person',
				els: [
					{
						tag: 'img',
						src: '/assets/images/persons/' + name + '.jpg',
						srcset: '/assets/images/persons/' + name + '.jpg, /assets/images/persons/' + name + '@2x.jpg 2x, /assets/images/persons/' + name + '@3x.jpg 3x'
					},
					{
						tag: 'div',
						className: 'description',
						els: [
							{
								tag: 'div',
								className: 'caption',
								text: D.Lang.get('about.team.' + name + '.title')
							},
							{
								tag: 'div',
								className: 'name',
								text: D.Lang.get('about.team.' + name + '.name')
							}
						]
					}
				]
			});
		}
	},
	Section
);
